"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restoreRulesSchema = exports.TriggerTypes = exports.isV2 = exports.isAllPreference = exports.isTeamsPreference = exports.isListsPreference = exports.isTaxPreference = exports.isSalariesPreference = exports.isAdjustmentPreference = exports.isSyncVariablePreference = exports.isVariablePreference = exports.isGoalsPreference = exports.isRulesPreference = exports.isReplacementPreference = exports.isAdjustmentRequestPreference = exports.PreferencesType = exports.GoalSummaryTypes = exports.ClosureVariableType = exports.CURRENT_PREFERENCES_VERSION = exports.PreferencesResponseVersions = void 0;
const zod_1 = require("zod");
var PreferencesResponseVersions;
(function (PreferencesResponseVersions) {
    PreferencesResponseVersions["v1"] = "v1";
    PreferencesResponseVersions["v2"] = "v2";
})(PreferencesResponseVersions = exports.PreferencesResponseVersions || (exports.PreferencesResponseVersions = {}));
exports.CURRENT_PREFERENCES_VERSION = PreferencesResponseVersions.v2;
var ClosureVariableType;
(function (ClosureVariableType) {
    ClosureVariableType["CREDITOR"] = "creditor";
    ClosureVariableType["CUSTOMER"] = "customer";
})(ClosureVariableType = exports.ClosureVariableType || (exports.ClosureVariableType = {}));
var GoalSummaryTypes;
(function (GoalSummaryTypes) {
    GoalSummaryTypes["SUM"] = "sum";
    GoalSummaryTypes["COUNT"] = "count";
    GoalSummaryTypes["AVG"] = "avg";
})(GoalSummaryTypes = exports.GoalSummaryTypes || (exports.GoalSummaryTypes = {}));
var PreferencesType;
(function (PreferencesType) {
    PreferencesType["ALL"] = "all";
    PreferencesType["SALARY"] = "salary";
    PreferencesType["VARIABLES"] = "variables";
    PreferencesType["SYNC_VARIABLES"] = "sync_variables";
    PreferencesType["ADJUSTMENTS"] = "adjustments";
    PreferencesType["GOALS"] = "goals";
    PreferencesType["TEAMS"] = "teams";
    PreferencesType["RULE"] = "rules";
    PreferencesType["TAX"] = "taxes";
    PreferencesType["LIST"] = "lists";
    PreferencesType["REPLACEMENTS"] = "replacements";
    PreferencesType["ADJUSTMENT_REQUESTS"] = "adjustment_requests";
})(PreferencesType = exports.PreferencesType || (exports.PreferencesType = {}));
const isAdjustmentRequestPreference = (pref, t) => t === PreferencesType.ADJUSTMENT_REQUESTS;
exports.isAdjustmentRequestPreference = isAdjustmentRequestPreference;
const isReplacementPreference = (pref, t) => t === PreferencesType.REPLACEMENTS;
exports.isReplacementPreference = isReplacementPreference;
const isRulesPreference = (pref, t) => t === PreferencesType.RULE;
exports.isRulesPreference = isRulesPreference;
const isGoalsPreference = (pref, t) => t === PreferencesType.GOALS;
exports.isGoalsPreference = isGoalsPreference;
const isVariablePreference = (pref, t) => t === PreferencesType.VARIABLES;
exports.isVariablePreference = isVariablePreference;
const isSyncVariablePreference = (pref, t) => t === PreferencesType.SYNC_VARIABLES;
exports.isSyncVariablePreference = isSyncVariablePreference;
const isAdjustmentPreference = (pref, t) => t === PreferencesType.ADJUSTMENTS;
exports.isAdjustmentPreference = isAdjustmentPreference;
const isSalariesPreference = (pref, t) => t === PreferencesType.SALARY;
exports.isSalariesPreference = isSalariesPreference;
const isTaxPreference = (pref, t) => t === PreferencesType.TAX;
exports.isTaxPreference = isTaxPreference;
const isListsPreference = (pref, t) => t === PreferencesType.LIST;
exports.isListsPreference = isListsPreference;
const isTeamsPreference = (pref, t) => t === PreferencesType.TEAMS;
exports.isTeamsPreference = isTeamsPreference;
const isAllPreference = (pref, t) => t === PreferencesType.ALL;
exports.isAllPreference = isAllPreference;
const isV2 = (p, type) => type === PreferencesResponseVersions.v2;
exports.isV2 = isV2;
var TriggerTypes;
(function (TriggerTypes) {
    TriggerTypes["CREATE_ADJUSTMENT"] = "create_adjustment";
    TriggerTypes["ADD_TO_LIST"] = "add_to_list";
})(TriggerTypes = exports.TriggerTypes || (exports.TriggerTypes = {}));
exports.restoreRulesSchema = zod_1.z.object({
    version_closure_date: zod_1.z.string().min(1),
    version_id: zod_1.z.string().min(1),
});
